import axios from 'axios';

const createAnnouncementApiInstance = () => {
  const baseURL =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
      ? 'http://localhost:10000/api3.2/announcements'
      : '/api3.2/announcements';

  return axios.create({ baseURL, withCredentials: true });
};

const announcementApi = createAnnouncementApiInstance();

export default announcementApi;
